module.exports = __webpack_public_path__ + "img/pricing-banner-graphics-mobile.533afc76.svg";